"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EvaluationClient = void 0;
const ConstraintUtils_1 = require("../ConstraintUtils");
const types_1 = require("../types");
const Messages_1 = __importDefault(require("../types/Messages"));
const handlers_1 = require("./handlers");
const DEFAULT_LIMIT_DISCLOSURE_TYPES = [types_1.ProofType.BbsBlsSignatureProof2020];
class EvaluationClient {
    constructor() {
        this.failed_catched = {
            tag: 'root',
            status: ConstraintUtils_1.Status.ERROR,
            message: Messages_1.default.UNKNOWN_EXCEPTION,
            stacktrace: '',
        };
        this._results = [];
        this._wrappedVcs = [];
        this._presentationSubmission = {};
        this._dids = [];
        this._limitDisclosureSignatureSuites = DEFAULT_LIMIT_DISCLOSURE_TYPES;
    }
    evaluate(pd, wvcs, holderDids, limitDisclosureSignatureSuites) {
        this._dids = holderDids || [];
        this._limitDisclosureSignatureSuites = limitDisclosureSignatureSuites;
        let currentHandler = this.initEvaluationHandlers();
        currentHandler === null || currentHandler === void 0 ? void 0 : currentHandler.handle(pd, wvcs);
        while (currentHandler === null || currentHandler === void 0 ? void 0 : currentHandler.hasNext()) {
            currentHandler = currentHandler.getNext();
            try {
                currentHandler === null || currentHandler === void 0 ? void 0 : currentHandler.handle(pd, wvcs);
            }
            catch (e) {
                this.failed_catched.message += e.message;
                this.failed_catched.stacktrace = e;
                throw this.failed_catched;
            }
        }
    }
    get results() {
        return this._results;
    }
    get dids() {
        return this._dids;
    }
    set dids(dids) {
        this._dids = dids;
    }
    get presentationSubmission() {
        return this._presentationSubmission;
    }
    set presentationSubmission(presentationSubmission) {
        this._presentationSubmission = presentationSubmission;
    }
    get wrappedVcs() {
        return this._wrappedVcs;
    }
    set wrappedVcs(wrappedVcs) {
        this._wrappedVcs = wrappedVcs;
    }
    get limitDisclosureSignatureSuites() {
        return this._limitDisclosureSignatureSuites || DEFAULT_LIMIT_DISCLOSURE_TYPES;
    }
    set limitDisclosureSignatureSuites(limitDisclosureSignatureSuites) {
        this._limitDisclosureSignatureSuites = limitDisclosureSignatureSuites;
    }
    initEvaluationHandlers() {
        const uriEvaluation = new handlers_1.UriEvaluationHandler(this);
        uriEvaluation
            .setNext(new handlers_1.InputDescriptorFilterEvaluationHandler(this))
            .setNext(new handlers_1.PredicateRelatedFieldEvaluationHandler(this))
            .setNext(new handlers_1.LimitDisclosureEvaluationHandler(this))
            .setNext(new handlers_1.SubjectIsIssuerEvaluationHandler(this))
            .setNext(new handlers_1.SubjectIsHolderEvaluationHandler(this))
            .setNext(new handlers_1.SameSubjectEvaluationHandler(this))
            .setNext(new handlers_1.MarkForSubmissionEvaluationHandler(this));
        return uriEvaluation;
    }
}
exports.EvaluationClient = EvaluationClient;
